import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Menu, X } from "lucide-react";
import homeLogo from '../Files/sarfare logo .png';
import otherLogo from '../Files/sarfare logo .png';
import BookScheduleModal from "./Forms/BookSchedule";

function Header({ isHomePage }) {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const headerClass = isHomePage ? "header-home" : "header-other";
  const logoToUse = isHomePage ? homeLogo : otherLogo;
  const [isScheduleOpen, setIsScheduleOpen] = useState(false);

  const openSchedule = () => {
    setIsScheduleOpen(true);
  };

  const closeSchedule = () => {
    setIsScheduleOpen(false);
  };

  return (
    <>
      <header className={`header ${headerClass}`}>
        <div className="header-container">
          {/* Logo */}
          <div className="logo">
            <Link to="/"><img src={logoToUse} alt="Logo" /></Link>
          </div>

          {/* Desktop Navigation */}
          <nav className="nav-center">
            <ul className="nav-links">
              <li><Link to="/" className="nav-link">Home</Link></li>
              <li><Link to="/about-us" className="nav-link">About</Link></li>
              <li><Link to="/properties" className="nav-link">Projects</Link></li>
              <li><Link to="/services" className="nav-link">Services</Link></li>
              <li><Link to="#" className="nav-link" onClick={() => {
                openSchedule();
              }}>Schedule</Link></li>
            </ul>
          </nav>

          {/* CTA and Hamburger */}
          <div className="cta">
            <Link to="/contact-us" className="cta-button">Contact Us</Link>
            <button className="hamburger-button" onClick={() => setDrawerOpen(true)}>
              <Menu size={24} />
            </button>
          </div>
        </div>
      </header>

      {/* Mobile Drawer */}
      <div className={`mobile-drawer ${drawerOpen ? "open" : ""}`}>
        <div className="mobile-drawer-header">
          <span>Menu</span>
          <button onClick={() => setDrawerOpen(false)}><X size={24} /></button>
        </div>
        <ul className="mobile-nav-links">
          <li><Link to="/" onClick={() => setDrawerOpen(false)}>Home</Link></li>
          <li><Link to="/about-us" onClick={() => setDrawerOpen(false)}>About</Link></li>
          <li><Link to="/properties" onClick={() => setDrawerOpen(false)}>Projects</Link></li>
          <li><Link to="/services" onClick={() => setDrawerOpen(false)}>Services</Link></li>
          <li><Link to="#" className="nav-link" onClick={() => {
            openSchedule();
            setDrawerOpen(false)
          }}>Schedule</Link></li>
        </ul>
        <div className="mobile-cta">
          <Link to="/contact-us" className="cta-button" onClick={() => setDrawerOpen(false)}>
            Contact Us
          </Link>
        </div>
      </div>


      <BookScheduleModal isOpen={isScheduleOpen} closeSchedule={closeSchedule} />
    </>
  );
}

export default Header;
